module.exports = __webpack_public_path__ + "static/img/big3.d2d6947.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big3.png
// module id = 9Xri
// module chunks = 1